/* Kkumi icon helper (JS side).
 *
 * Mirrors snippets/kkumi-icon.liquid for scripts that build DOM at runtime.
 * Used wherever asset JS would otherwise inject an emoji (account hub,
 * dashboard, track page, club, FBT, reviews wall, deco finder, admin UI).
 *
 * Usage:
 *   var span = KKIcons.el('crown', 'kka-tbadge__icon');     // <span class="…"><svg …></span>
 *   var html = KKIcons.html('sparkles');                    // raw SVG string
 *   KKIcons.svg('fire')                                     // alias of html()
 *
 * Trailing CTA arrows — the JS twin of snippets/kkumi-label-arrow.liquid, for
 * buttons built at runtime. Same authoring rule as the snippet: a trailing
 * `→` in the label (merchant copy, or an in-code fallback) is stripped and
 * re-drawn as the shared arrow-right SVG.
 *   KKIcons.labelHTML('Use it now →')      // 'Use it now <span class="kk-arrow">…</span>'
 *   KKIcons.labelInto(a, 'Use it now →')   // same, built as DOM nodes
 *
 * The SVG markup below is trusted (defined here, not interpolated from API
 * data), so it's safe to set with innerHTML.
 */
(function () {
  'use strict';
  if (window.KKIcons) return;
  // width/height = 1em so the SVG inherits the parent's font-size (the existing
  // emoji spans rely on font-size for sizing). Override per-instance via CSS:
  //   .kka-tbadge__icon svg { width: 24px; height: 24px; }
  var BASE = '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var END = '</svg>';
  var SHAPES = {
    'check':           '<polyline points="20 6 9 17 4 12"></polyline>',
    'clock':           '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
    'chat':            '<path d="M21 11.5a8.4 8.4 0 0 1-12.3 7.6L3 21l1.9-5.7A8.5 8.5 0 1 1 21 11.5z"></path>',
    'users':           '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
    'copy':            '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
    'x':               '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
    'check-circle':    '<path d="m9 12 2 2 4-4"></path><circle cx="12" cy="12" r="10"></circle>',
    'truck':           '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
    'shield-check':    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path>',
    'rotate-ccw':      '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"></path><path d="M3 3v5h5"></path>',
    'box':             '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    'globe':           '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
    'lock':            '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
    'gift':            '<rect x="3" y="9" width="18" height="11" rx="1"></rect><path d="M3 13h18M12 9v11M12 9S10 4 7.5 5 9 9 12 9Zm0 0s2-5 4.5-4-.5 4-4.5 4Z"></path>',
    'tag':             '<path d="M3 11.5V4a1 1 0 0 1 1-1h7.5a1 1 0 0 1 .7.3l8.5 8.5a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0L3.3 12.2a1 1 0 0 1-.3-.7Z"></path><circle cx="7.5" cy="7.5" r="1.4"></circle>',
    'cake':            '<path d="M4 20h16v-7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v7Z"></path><path d="M4 15c2 0 2 1.5 4 1.5S10 15 12 15s2 1.5 4 1.5S18 15 20 15M12 7V4M9 7V5M15 7V5"></path>',
    'star':            '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
    'heart':           '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
    'seedling':        '<path d="M12 20v-7"></path><path d="M12 13c-3 0-6-2-6-6 3 0 6 2 6 6Z"></path><path d="M12 13c3 0 6-2 6-6-3 0-6 2-6 6Z"></path><path d="M5 20h14"></path>',
    'crown':           '<path d="M3 7l4 4 5-6 5 6 4-4-2 12H5L3 7Z"></path><path d="M5 19h14"></path>',
    'sparkles':        '<path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3Z"></path><path d="M18 14l.8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8L18 14Z"></path>',
    'mail':            '<rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="m3 7 9 7 9-7"></path>',
    'mail-heart':      '<rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="m3 7 9 7 9-7"></path><path d="M12 17c-1.5-1.2-3-2.3-3-3.5a1.5 1.5 0 0 1 3-.5 1.5 1.5 0 0 1 3 .5c0 1.2-1.5 2.3-3 3.5Z" fill="currentColor" stroke="none"></path>',
    'mailbox':         '<path d="M3 11a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v9H3v-9Z"></path><path d="M8 11v9"></path><path d="M11 14h6"></path><path d="M16 6V3h-3"></path>',
    'party':           '<path d="M3 21l3-12 9 9-12 3Z"></path><path d="M14 4l1.5 1.5M19 4v2M21 9h-2M17 11l2 2M14 8l3-3"></path>',
    'fire':            '<path d="M12 21c3.5 0 6-2.5 6-6 0-3-2-5-3-7-1 2-2 3-3 3 0-2-1-4-3-5 0 4-3 6-3 9 0 3.5 2.5 6 6 6Z"></path>',
    'alert-triangle':  '<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"></path><line x1="12" y1="9.5" x2="12" y2="13.5"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
    'exclamation':     '<line x1="12" y1="6" x2="12" y2="13.5"></line><line x1="12" y1="17.6" x2="12.01" y2="17.6"></line>',
    'list':            '<path d="M5 7h14M5 12h9M5 17h5"></path>',
    'arrow-left':      '<path d="M19 12H6M11 6l-6 6 6 6"></path>',
    'arrow-right':     '<path d="M5 12h13M13 6l6 6-6 6"></path>',
    'instagram':       '<rect x="2.5" y="2.5" width="19" height="19" rx="5.5"></rect><circle cx="12" cy="12" r="4.2"></circle><circle cx="17.6" cy="6.4" r="1.2" fill="currentColor" stroke="none"></circle>',
    'play':            '<path d="M8 5.5v13l11-6.5z" fill="currentColor" stroke="none"></path>',
  };
  // Solid variants (mirrors the `-fill` block in snippets/kkumi-icon.liquid).
  // One evenodd path each, so inner detail is a hole the surface behind
  // shows through — what to use on a coloured badge, where a hairline
  // outline turns to mush at badge sizes.
  var FILL_BASE = '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" aria-hidden="true">';
  var FILLS = {
    'heart-fill':          '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>',
    'alert-triangle-fill': '<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Zm1.71 4.9a1.15 1.15 0 0 1 1.15 1.15v4.3a1.15 1.15 0 0 1-2.3 0v-4.3A1.15 1.15 0 0 1 12 8.76Zm0 7.42a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"/>',
    'info-fill':           '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 3.9a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Zm0 4.2a1.15 1.15 0 0 1 1.15 1.15v5.4a1.15 1.15 0 0 1-2.3 0v-5.4A1.15 1.15 0 0 1 12 10.1Z"/>',
    'exclamation-fill':    '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 4.1a1.15 1.15 0 0 1 1.15 1.15v6a1.15 1.15 0 0 1-2.3 0v-6A1.15 1.15 0 0 1 12 6.1Zm0 9.15a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Z"/>',
    'check-circle-fill':   '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.86 7.3a1.15 1.15 0 0 0-1.72-1.52l-4.4 4.98-1.9-1.9a1.15 1.15 0 1 0-1.62 1.62l2.77 2.77a1.15 1.15 0 0 0 1.67-.05l5.2-5.9Z"/>',
    'star-fill':           '<path d="M12 2.6a.9.9 0 0 1 .81.5l2.5 5.07 5.6.81a.9.9 0 0 1 .5 1.54l-4.05 3.95.96 5.57a.9.9 0 0 1-1.31.95L12 18.36l-5.01 2.63a.9.9 0 0 1-1.31-.95l.96-5.57-4.05-3.95a.9.9 0 0 1 .5-1.54l5.6-.81 2.5-5.07a.9.9 0 0 1 .81-.5Z"/>',
    'sparkles-fill':       '<path d="M11.05 2.67a1 1 0 0 1 1.9 0l1.4 3.86 3.86 1.4a1 1 0 0 1 0 1.88l-3.86 1.4-1.4 3.86a1 1 0 0 1-1.9 0l-1.4-3.86-3.86-1.4a1 1 0 0 1 0-1.88l3.86-1.4 1.4-3.86ZM18 13.4a.9.9 0 0 1 .85.6l.63 1.73 1.73.63a.9.9 0 0 1 0 1.69l-1.73.63-.63 1.73a.9.9 0 0 1-1.7 0l-.63-1.73-1.73-.63a.9.9 0 0 1 0-1.69l1.73-.63.63-1.73a.9.9 0 0 1 .85-.6Z"/>',
  };
  function html(name) {
    if (name && name.indexOf('-fill') !== -1) {
      return FILL_BASE + (FILLS[name] || FILLS['check-circle-fill']) + END;
    }
    return BASE + (SHAPES[name] || SHAPES['check']) + END;
  }
  function elFor(name, className) {
    var span = document.createElement('span');
    if (className) span.className = className;
    span.innerHTML = html(name);
    return span;
  }

  // ── Trailing CTA arrow (twin of snippets/kkumi-label-arrow.liquid) ──────
  // Keep the two in lockstep: same trailing-`→` rule, same `.kk-arrow` span,
  // same arrow-right glyph. Styling lives once on `.kk-arrow`
  // (assets/kkumi-tokens.css).
  function splitArrow(text, force) {
    var t = String(text == null ? '' : text).replace(/\s+$/, '');
    var arrow = !!force;
    if (t.charAt(t.length - 1) === '\u2192') {
      arrow = true;
      t = t.slice(0, -1).replace(/\s+$/, '');
    }
    return { text: t, arrow: arrow };
  }
  function arrowSpan(className) {
    return elFor('arrow-right', 'kk-arrow' + (className ? ' ' + className : ''));
  }
  // HTML-string form, for the concat builders. The label is escaped here (the
  // canonical window.KKEsc, with the house fallback for load-order safety), so
  // the result is safe to assign to innerHTML.
  function labelHTML(text, opts) {
    opts = opts || {};
    var esc = window.KKEsc || function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var p = splitArrow(text, opts.force);
    if (!p.arrow) return esc(p.text);
    var span = '<span class="kk-arrow' + (opts['class'] ? ' ' + opts['class'] : '') + '">' + html('arrow-right') + '</span>';
    return p.text ? esc(p.text) + ' ' + span : span;
  }
  // DOM form, for the places that deliberately never put runtime strings
  // through innerHTML (the cart toast's action link). Replaces the node's
  // contents: label as a text node, arrow as an element.
  function labelInto(node, text, opts) {
    if (!node) return node;
    opts = opts || {};
    var p = splitArrow(text, opts.force);
    node.textContent = p.text;
    if (p.arrow) {
      if (p.text) node.appendChild(document.createTextNode(' '));
      node.appendChild(arrowSpan(opts['class']));
    }
    return node;
  }

  window.KKIcons = {
    html: html, svg: html, el: elFor,
    labelHTML: labelHTML, labelInto: labelInto,
    names: Object.keys(SHAPES).concat(Object.keys(FILLS)),
  };
})();
